module.exports = __webpack_public_path__ + "static/media/d54kzz.10bc786c.pdf";